import { Container } from 'react-bootstrap';
import Button from '../../../components/Button';
import useModal from '../../../hooks/useModal';
import { formatPrice } from '../../../utils/utils';
import FormsOfPaymentModal from './FormsOfPaymentModal';

const formsOfPaymentData1 = [
  {
    title: 'Single Life Anuity',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(3565.0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(11719.58, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '50% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2512.0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1256.0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '66 2/3% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2247.212, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '75% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1994.6, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '100% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2822, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2243, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1876, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2165.29, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(2247.12, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1994.6, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2822, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2243, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1876, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },
];

const FormsOfPaymentModalDemo = () => {
  const [
    showFormsOfPaymentModal,
    handleShowFormsOfPaymentModal,
    handleCloseFormsOfPaymentModal,
  ] = useModal();

  return (
    <Container>
      <Button onClick={handleShowFormsOfPaymentModal}>
        Forms Of Payment Modal
      </Button>
      <FormsOfPaymentModal
        showFormsOfPaymentModal={showFormsOfPaymentModal}
        handleCloseFormsOfPaymentModal={handleCloseFormsOfPaymentModal}
        modalData={formsOfPaymentData1}
      />
    </Container>
  );
};

export default FormsOfPaymentModalDemo;
